/* KILUKRU — Bons plans : copie du code promo en un clic. */
(function () {
  'use strict';

  var RESET_DELAY = 2000;

  function feedback(button) {
    var action = button.querySelector('.kk-bp-code__action');
    if (!action) return;
    if (button.dataset.kkResetting === 'true') return;

    var initial = action.textContent;
    button.dataset.kkResetting = 'true';
    button.classList.add('is-copied');
    action.textContent = 'Copié !';

    setTimeout(function () {
      button.classList.remove('is-copied');
      action.textContent = initial;
      button.dataset.kkResetting = 'false';
    }, RESET_DELAY);
  }

  function copy(text) {
    if (navigator.clipboard && window.isSecureContext) {
      return navigator.clipboard.writeText(text);
    }

    var field = document.createElement('textarea');
    field.value = text;
    field.setAttribute('readonly', '');
    field.style.position = 'absolute';
    field.style.left = '-9999px';
    document.body.appendChild(field);
    field.select();
    try {
      document.execCommand('copy');
      return Promise.resolve();
    } catch (error) {
      return Promise.reject(error);
    } finally {
      document.body.removeChild(field);
    }
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-kk-copy]');
    if (!button) return;

    copy(button.dataset.kkCopy).then(
      function () {
        feedback(button);
      },
      function () {
        /* Presse-papier indisponible : on laisse le code visible, lisible et sélectionnable. */
      }
    );
  });
})();
